module.exports = __webpack_public_path__ + "static/media/strack.2b559b3d.png";